import { findindex } from './findindex';
import moment from 'moment';
import { store, app } from '..';
export const runinvoices = (weDate, wods, startdate) => {
  var custinfo = Array.from(store.getState().custinfo.customers);
  console.log(custinfo);

  console.log('running invoices for ' + weDate);
  // for this weDate will be the enddate, and startdate is what it says it is.
  var invoiceproto = {
    custnumber: '',
    number: '',
    workordernumber: '99-9999',
    description: 'DATABASE TESTING',
    periodbegindate: '2017-01-01',
    periodenddate: moment(weDate).format('YYYY-MM-DD'),
    createdate: moment().format('YYYY-MM-DD'),
    amount: 50000,
    submitdate: moment().format('YYYY-MM-DD'),
    paiddate: null,
    fixedpriceind: 0,
    fixedpricepercent: 0,
    included: true,
    app2ind: null,
    notification: null,
    paidamount: 0,
    createdAt: '2017-09-27T21:03:18.000Z',
    updatedAt: '2017-09-27T22:09:51.000Z'
  };
  var labortotal;
  var mattotal;
  var newinvs = [];
  let invnumlist = [];
  var periodbegine;
  if (wods.length) {
    return queryfunction(weDate, wods, startdate)
      .then(response => {
        response = response.data ? response.data : response;
        if (response.length > 0) {
          var periodbegin;
          if (startdate) {
            // this sets startdate if it exists to the predefined arg.
            periodbegin = startdate;
          } else {
            /* this handles the condition that the arg startdate is undefined
          and creates the startdate based on the first wedate of the queried tnms.
*/
            periodbegin = response[0].wedate;
          }
          response.map((tnm, index) => {
            let wod = wods.find(
              wod => tnm.workordernumber === wod.workOrderNbr
            );
            console.log(wod);

            if (wod && !wod.fixedPrice) {
              let wonton = wod.invWorkOrderMain
                ? tnm.workordernumber.slice(0, 7)
                : tnm.workordernumber;
              console.log(wonton);

              // if workorders are invoiced as main grab main wod for processing
              if (wod && wod.invWorkOrderMain) {
                console.log('invoiceing as main');
                // wonton = wonton.slice(0, 7);
                // windex = findindex(wonton, wods, "workOrderNbr");
                // wod = wods[windex];
              }
              let invindex = newinvs.findIndex(
                invoice => invoice.workordernumber === wonton
              );

              if (invindex === -1) {
                console.log('Wonton is' + '\n' + wonton.toString());
                let custindex = custinfo.findIndex(
                  cust => cust.custnumber === tnm.custnumber
                );
                var tempcustomer = Object.assign({}, custinfo[custindex]);
                // custinfo[custindex].nextinvnumber
                let amount =
                  tnm.amount % 1 === 0 ? tnm.amount : tnm.amount.toFixed(2);
                var newinvce = {
                  ...invoiceproto,
                  index: index,
                  periodbegindate: periodbegin,
                  periodenddate: response[response.length - 1].wedate,
                  workordernumber: wonton,
                  number: custinfo[custindex].nextinvnumber,
                  custnumber: tnm.custnumber,
                  description: tnm.description,
                  amount: amount,
                  tmids: [tnm.id]
                };

                newinvs = newinvs.concat(newinvce);
                tempcustomer.nextinvnumber =
                  parseInt(tempcustomer.nextinvnumber) + 1;
                console.log(tempcustomer.nextinvnum);

                custinfo[custindex] = tempcustomer;
              } else {
                let patchinv = newinvs[invindex];
                let enddate = patchinv.wedate;
                if (tnm.wedate > enddate) {
                  enddate = tnm.wedate;
                }
                patchinv = {
                  ...patchinv,
                  amount:
                    parseFloat(patchinv.amount) +
                    Math.round(tnm.amount * 100) / 100,
                  tmids: patchinv.tmids.concat(tnm.id)
                };
                patchinv.amount =
                  patchinv.amount % 1 === 0
                    ? patchinv.amount
                    : patchinv.amount.toFixed(2);
                newinvs[invindex] = patchinv;
              }
            }
          });
          // export const findindex = (value, array, param) => {
        }
      })
      .then(() => {
        return newinvs;
      });
  }
};

const queryfunction = (weDate, wods, startdate) => {
  if (startdate) {
    // this query uses predefined startdate like custom invoices
    return app.service('tmsheets').find({
      query: {
        wedate: { $lte: weDate, $gte: startdate },
        invoicenumber: null,
        $sort: { wedate: 1 }
      }
    });
  } else {
    // this query does not.
    return app.service('tmsheets').find({
      query: {
        wedate: { $lte: weDate },
        invoicenumber: null,
        $sort: { wedate: 1 }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/geninvoices.js